module.exports = __webpack_public_path__ + "static/media/drag.4a708fde.svg";